import { render, staticRenderFns } from "./AppSmashing.vue?vue&type=template&id=033cc508&scoped=true&"
import script from "./AppSmashing.vue?vue&type=script&lang=js&"
export * from "./AppSmashing.vue?vue&type=script&lang=js&"
import style0 from "./AppSmashing.vue?vue&type=style&index=0&id=033cc508&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033cc508",
  null
  
)

export default component.exports